import {
    ADD_DEPARTMENT_REQUEST,
    ADD_DEPARTMENT_SUCCESS,
    ADD_DEPARTMENT_FAILURE,
    FETCH_DEPARTMENTS_REQUEST,
    FETCH_DEPARTMENTS_SUCCESS,
    FETCH_DEPARTMENTS_FAILURE,
    UPDATE_DEPARTMENT_REQUEST,
    UPDATE_DEPARTMENT_SUCCESS,
    UPDATE_DEPARTMENT_FAILURE,
    DELETE_DEPARTMENT_REQUEST,
    DELETE_DEPARTMENT_SUCCESS,
    DELETE_DEPARTMENT_FAILURE,
} from '../actions/departmentActionTypes';


const initialState = {
    departments: [], //Array to store the departments fetched from the API
    isLoading: false, //Loading state for fetching departments
    addDepartmentError: null, //Error state for adding a department
    fetchDepartmentsError: null, //Error state for fetching departments
    updateDepartmentError: null, //Error state for updating a department
    deleteDepartmentError: null, //Error state for deleting a department
};




const departmentReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_DEPARTMENT_REQUEST:
            return {
                ...state,
                isLoading: true,
                addDepartmentError: null,
            };

        case ADD_DEPARTMENT_SUCCESS:
            return {
                ...state,
                departments: [...state.departments, action.payload],
                isLoading: false,
                addDepartmentError: null,
            };

        case ADD_DEPARTMENT_FAILURE:
            return {
                ...state,
                isLoading: false,
                addDepartmentError: action.payload,
            };

        case FETCH_DEPARTMENTS_REQUEST:
            return {
                ...state,
                isLoading: true,
                fetchDepartmentsError: null, //Reset errors on request
            };

        case FETCH_DEPARTMENTS_SUCCESS: 
            return {
                ...state,
                departments: action.payload, //Store the departments data
                isLoading: false, //Stop loading
                fetchDepartmentsError: null, //Clear any previous departments error
            };

        case FETCH_DEPARTMENTS_FAILURE: 
            return {
                ...state,
                isLoading: false, //Stop loading
                fetchDepartmentsError: action.payload, //Store the error message
            };


        case UPDATE_DEPARTMENT_REQUEST: 
            return {
                ...state,
                isLoading: true,
                updateDepartmentError: null
            }

        
        case UPDATE_DEPARTMENT_SUCCESS: 
            return {
                ...state,
                departments: state.departments.map(department =>
                    department.id === action.payload.id ? action.payload : department
                ),
                isLoading: false,
                updateDepartmentError: null
            }


        case UPDATE_DEPARTMENT_FAILURE: 
            return {
                ...state,
                isLoading: false,
                updateDepartmentError: action.payload
            }


        case DELETE_DEPARTMENT_REQUEST:
            return {
                ...state,
                isLoading: true,
                deleteDepartmentError: null
            };


        case DELETE_DEPARTMENT_SUCCESS:
            return {
                ...state,
                departments: state.departments.filter((department) => department.id !== action.payload),
                isLoading: false,
                deleteDepartmentError: null
            };

        
        case DELETE_DEPARTMENT_FAILURE:
            return {
                ...state,
                isLoading: false,
                deleteDepartmentError: action.payload
            }
            default:
                return state;
    }

};

export default departmentReducer;